import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {SideNavBarVisibilityService} from '../../services/side-nav-bar-visibility.service';
import {AdminDashboardService} from '../../services/admin-dashboard.service';
import {NotificationService} from '../../services/notification.service';
import {ZPNotification} from '../../models/zpnotification';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
  selector: 'app-mail-queue',
  templateUrl: './mail-queue.component.html',
  styleUrls: ['./mail-queue.component.scss']
})
export class MailQueueComponent implements OnInit {
  public list = [];
  public lineState = [];
  public section = "email_queue";
  public Id: any;

  constructor(private router: Router, 
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private api: AdminDashboardService, private notifications:NotificationService, public themeService: ThemeService) { }

  ngOnInit(): void {
    this.reloadList();
  }

  async reloadList(){
    this.list = await this.api.getList(this.section);
    this.list.forEach(element => {
      this.Id = element.data.user.Id
    })
  }

  async saveItem(index){
    let item = this.list[index];
    let result = await this.api.putItem(this.section,item);
    if(result && result.success){
      this.notifications.changeMessage(new ZPNotification("Item Saved"))
      this.toggleSection(index);
      this.reloadList();
    }else{
      this.notifications.changeMessage(new ZPNotification("Save failed"))
    }
  }

  async deleteItem(index) {
    let item = this.list[index];
    let success = await this.api.deleteItem(this.section,item);
    if (success) {
      this.notifications.changeMessage(new ZPNotification("Item has been deleted"))
      this.reloadList();
    } else {
      this.notifications.changeMessage(new ZPNotification("Item has been deleted"))
    }
  }

  toggleSection(index){
    if(this.lineState[index]){
      this.lineState[index] = false;
    }else{
      this.lineState[index] = true;
    }
  }

  refreshContent() {
    window.location.reload();
  }

  redirectTo() {
    this.router.navigate(['/mail-log-details/' + this.Id])
  }
}
